import { render, staticRenderFns } from "./AppointmentsItemView.vue?vue&type=template&id=60c41b54&scoped=true&"
import script from "./AppointmentsItemView.vue?vue&type=script&lang=ts&"
export * from "./AppointmentsItemView.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentsItemView.vue?vue&type=style&index=0&id=60c41b54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c41b54",
  null
  
)

export default component.exports